import React from 'react';
import PropTypes from 'prop-types';

import { DarkScreenMask, HorizontalSeparator } from '../../..';
import closeIcon from '../../../assets/imgs/icon-close.svg';
import './TeamsListModal.scss';

const TeamsListModal = ({ teams, isVisible, onTeamSelect, onClose })=> {
  return (
    <DarkScreenMask isVisible={isVisible}>
      <div className="teams-list-modal">
        <button className="teams-list-modal__close-button" onClick={onClose}>
          <img src={closeIcon} alt=""/>
        </button>
        <div className="teams-list-modal__teams">
        {teams.map(team =>
          <div className="teams-list-modal__teams__single-team">
            <button 
              className="teams-list-modal__teams__single-team__button" 
              type="" 
              onClick={()=> onTeamSelect(team)}
            >
              <img className="teams-list-modal__teams__single-team__button__team-image" src={team.teamImage} alt=""/>
              <span className="teams-list-modal__teams__single-team__button__name">{team.name}</span>
            </button>
            <HorizontalSeparator />
          </div> 
        )}

        </div>
      </div>
    </DarkScreenMask>
  );
};

TeamsListModal.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  onTeamsSelect: PropTypes.func,   
  teams: PropTypes.array
};

TeamsListModal.defaultProps = {
  isVisible: false,
  onClose: ()=> {}, 
  onTeamsSelect: ()=> {},   
  teams: []
};

export default TeamsListModal;